/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// utils
import { generateClasses } from 'utils/generators';
// material
import Icon from 'material/graphic/icon/icon';
import Group from 'material/group/group';
// styles
import styles from 'material/message/alert/alert_styles';
import injectSheet from 'react-jss';

// Note: From now on, use this for static messages and banners

/* ========== ~~~~~~~~~~ ALERT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Alert extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: props.display
        }
    }

    handleClose = () => {
        if (this.props.handleClose) {
            this.setState({
                display: false
            });
            this.props.handleClose();
        }
    }

    render() {
        return (
            <div className={`message alert display-${this.state.display} ${generateClasses(this.props)} ${this.props.classes.alert}`}>
                <Group name={`icon-text`}>
                    <Icon name={`${this.props.icon} alert-icon`}/>
                    <p className={`title-text`}>{this.props.title &&
                    <strong className={`title`}>{this.props.title}:</strong>}{this.props.text}</p>
                </Group>
                {this.props.close && <span onClick={this.handleClose}><Icon name={'times'}/></span>}
            </div>
        )
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Alert);